// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__35goL","footer":"Form_footer___wVW-"};